export default __webpack_public_path__ + "static/media/inovacao-icon.53522934.svg";